import classnames from 'classnames';
import React, { useState } from 'react';
import Button from 'Shared/Button';
import Icon from 'Shared/Icon';
import { translate } from 'Shared/translate';
import * as styles from '../base.scss';
const MobileFiltersAndFacets = (props) => {
    const [isOpen, setOpen] = useState(false);
    const toggleFacets = () => {
        setOpen(!isOpen);
    };
    const closeFacets = () => {
        setOpen(false);
    };
    const buttonText = (count) => {
        if (count == 0)
            return translate('/Shared/NoHits');
        if (props.hasActiveCustomFilters)
            return translate('/ProductListing/FadeShowsMobile', "");
        return count > 1 ? translate('/ProductListing/FadeShowsMobile', props.totalCount) : translate('/ProductListing/FadeShowsOneMobile', props.totalCount);
    };
    const countActiveFilters = (initial) => {
        props.facets.filter(x => x.facetValues.filter(y => y.selected)).forEach((x) => {
            initial += x.facetValues.filter(y => y.selected).length;
        });
        return initial;
    };
    const totalSelectedFiltersCount = !!props.facets ? countActiveFilters(props.activeCustomFilterCount) : props.activeCustomFilterCount;
    return (React.createElement("div", { className: classnames(styles.mobileFilterWrapper, { [styles.open]: isOpen }) },
        React.createElement("div", { className: classnames(styles.mobileFilterWrapperFiltersList, { [styles.open]: isOpen }) },
            React.createElement("div", { className: styles.mobileFilterWrapperTop },
                React.createElement(Button, { appearance: ['tertiary', 'large'], className: styles.toggler, onClick: () => toggleFacets(), disabled: false },
                    React.createElement("span", null, translate('/Shared/Filter')),
                    totalSelectedFiltersCount > 0 && (React.createElement("span", null,
                        "(",
                        totalSelectedFiltersCount,
                        ")")),
                    React.createElement(Icon, { name: "filter" }),
                    React.createElement(Icon, { name: "close" }))),
            React.createElement("div", { className: styles.mobileFilterWrapperMiddle }, props.children),
            React.createElement("div", { className: styles.mobileFilterWrapperBottom },
                React.createElement(Button, { appearance: ['tertiary'], className: styles.closeButton, onClick: () => closeFacets(), disabled: false },
                    React.createElement("span", null, buttonText(props.totalCount)))))));
};
export default MobileFiltersAndFacets;
